<div class="help-container">
  <button
    type="button"
    class="help-toggle"
    (click)="onToggle()"
    (keydown)="onToggleKeydown($event)"
    tid="manual-setup-toggle"
    [attr.aria-expanded]="expanded()"
    aria-controls="help-content"
  >
    @if (expanded()) {
      Show less
    } @else {
      Need more help?
    }
    <ci-phosphor-icon
      name="caret-down"
      weight="regular"
      size="sm"
      variant="inherit"
      class="toggle-icon"
      [class.expanded]="expanded()"
      aria-hidden="true"
    />
  </button>
  @if (expanded()) {
    <ul class="instruction-text">
      <li>You can download <strong>Microsoft</strong> or <strong>Google Authenticator</strong> from your phone's app store.</li>
      <li>Once installed, open it and scan the QR code below to connect it to your Cintra People account.</li>
      <li>Can't scan the code? Tap <strong>Set up manually</strong> below instead.</li>
    </ul>
    <p class="instruction-text">
      For more information on authenticator apps, see
      <a [href]="helpLinks.getUrl(HelpLinkType.AuthenticatorApps)" target="_blank" rel="noopener noreferrer"
        ><strong>Cintra Help</strong></a
      >
    </p>
  }
</div>
